<script setup lang="ts">
/** BON08 — Section 78 Return of Allotment (SSM lodgement). Share class 표 + Allottee 표 + 서명. */
import { computed, inject } from 'vue';
import { BONUS_DOC_CTX } from './bonusContext';
import BonusDocVarField from './BonusDocVarField.vue';
import BonusDocHead from './parts/BonusDocHead.vue';
import BonusAllotteeTable from './parts/BonusAllotteeTable.vue';
import BonusSigners from './parts/BonusSigners.vue';

const ctx = inject(BONUS_DOC_CTX)!;
const shareRows = computed(() => Array.from({ length: ctx.shareClassCount.value }, (_, i) => i + 1));
</script>

<template>
  <div class="allot-doc">
    <BonusDocHead />
    <p class="doc-sec-title">RETURN OF ALLOTMENT OF SHARES</p>
    <p class="doc-meta" style="text-align:center">(Section 78, Companies Act 2016)</p>

    <p class="doc-p" style="margin-top:12px">
      Return of allotment of shares made during the period from <BonusDocVarField field-key="period_start_date" /> to
      <BonusDocVarField field-key="period_end_date" /> (date of allotment: <BonusDocVarField field-key="allotment_date" />).
    </p>

    <p class="doc-lbl-title">A. SHARES ALLOTTED</p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <th style="width:36px">#</th>
          <th>Class &amp; Details of Shares</th>
          <th>No. of Shares</th>
          <th>Price / Share (RM)</th>
          <th>Total Issued (RM)</th>
          <th style="width:44px"></th>
        </tr>
        <tr v-for="(n, i) in shareRows" :key="n">
          <td>{{ i + 1 }}</td>
          <td>
            <BonusDocVarField :field-key="`share_class_type_${n}`" placeholder="Type (e.g. Ordinary)" /><br />
            <BonusDocVarField :field-key="`share_class_details_${n}`" placeholder="Details of Shares" />
          </td>
          <td><BonusDocVarField :field-key="`share_class_number_${n}`" placeholder="Number" /></td>
          <td><BonusDocVarField :field-key="`share_class_price_${n}`" placeholder="Price" /></td>
          <td><BonusDocVarField :field-key="`share_class_total_${n}`" placeholder="Total" /></td>
          <td>
            <button v-if="ctx.shareClassCount.value > 1" class="bon-rowbtn" title="Remove" @click="ctx.removeShareClass(i + 1)">✕</button>
          </td>
        </tr>
        <tr><td colspan="6"><button class="bon-addrow" @click="ctx.addShareClass()">+ Add share class</button></td></tr>
      </tbody>
    </table>

    <p class="doc-lbl-title">B. TOTALS OF SHARES ALLOTTED</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><th></th><th>Paid in Cash (RM)</th><th>Paid Otherwise (RM)</th><th>Total (RM)</th></tr>
        <tr>
          <td class="cdd-sec">Allotment in this return</td>
          <td><BonusDocVarField field-key="total_current_cash" /></td>
          <td><BonusDocVarField field-key="total_current_otherwise" /></td>
          <td><BonusDocVarField field-key="total_current" /></td>
        </tr>
        <tr>
          <td class="cdd-sec">Additional in this return</td>
          <td><BonusDocVarField field-key="total_additional_cash" /></td>
          <td><BonusDocVarField field-key="total_additional_otherwise" /></td>
          <td><BonusDocVarField field-key="total_additional" /></td>
        </tr>
        <tr>
          <td class="cdd-sec">Accumulated to date</td>
          <td><BonusDocVarField field-key="total_accumulated_cash" /></td>
          <td><BonusDocVarField field-key="total_accumulated_otherwise" /></td>
          <td><BonusDocVarField field-key="total_accumulated" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-lbl-title">C. PARTICULARS OF ALLOTTEES</p>
    <BonusAllotteeTable :show-id-no="true" :show-share-type="true" :show-total="true" shares-header="No. of Shares" />

    <p class="doc-p" style="margin-top:14px">I declare that the information given in this return is true and correct.</p>
    <BonusSigners var-key="s78_return" />
    <table class="cdd-tbl" style="margin-top:8px">
      <tbody>
        <tr><td class="cdd-lcell">Name of Director</td><td><BonusDocVarField field-key="director_name" /></td></tr>
        <tr><td>NRIC</td><td><BonusDocVarField field-key="director_nric" /></td></tr>
        <tr><td>Date</td><td><BonusDocVarField field-key="signature_date" /></td></tr>
      </tbody>
    </table>
  </div>
</template>
